import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import AuditLogsTab from './Settings/AuditLogsTab';
import TariffsTab from './Settings/TariffsTab';
import ProvincesTab from './Settings/ProvincesTab';
import DistrictsTab from './Settings/DistrictsTab';
import BarriersTab from './Settings/BarriersTab';
import RolesTab from './Settings/RolesTab';
import BrandsTab from './Settings/BrandsTab';
import ColorsTab from './Settings/ColorsTab';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('audit-logs');
  const { getMessage } = useTranslation();

  const tabs = [
    {
      key: 'audit-logs',
      label: getMessage('settings.audit_logs') || 'Audit Logs',
      icon: '📋',
      component: AuditLogsTab
    },
    {
      key: 'tariffs',
      label: getMessage('settings.tariffs') || 'Tariffs',
      icon: '💰',
      component: TariffsTab
    },
    {
      key: 'provinces',
      label: getMessage('settings.provinces') || 'Provinces',
      icon: '🗺️',
      component: ProvincesTab
    },
    {
      key: 'districts',
      label: getMessage('settings.districts') || 'Districts',
      icon: '🏘️',
      component: DistrictsTab
    },
    {
      key: 'barriers',
      label: getMessage('settings.barriers') || 'Barrier System',
      icon: '🚧',
      component: BarriersTab
    },
    {
      key: 'roles',
      label: getMessage('settings.roles') || 'Roles & Permissions',
      icon: '🔐',
      component: RolesTab
    },
    {
      key: 'brands',
      label: getMessage('settings.brands') || 'Brands',
      icon: '🚗',
      component: BrandsTab
    },
    {
      key: 'colors',
      label: getMessage('settings.colors') || 'Colors',
      icon: '🎨',
      component: ColorsTab
    }
  ];

  const ActiveComponent = tabs.find(tab => tab.key === activeTab)?.component;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      {/* Page Header */}
      <div className="border-b border-gray-200 dark:border-gray-700 px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              ⚙️ {getMessage('settings.title') || 'System Settings'}
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {getMessage('settings.description') || 'Manage system configurations, audit logs, tariffs, and more'}
            </p>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="flex space-x-8 px-6" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${activeTab === tab.key
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 hover:border-gray-300'
                }`}
            >
              <span className="flex items-center space-x-2">
                <span className="text-lg">{tab.icon}</span>
                <span>{tab.label}</span>
              </span>
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="p-6">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
}